import { UITable } from 'libraui-extension'
const manifest = {
  name: 'name',
  label: 'label',
  type: 'type',
  uiTable: UITable.BillItemBase,
  props: [
  ],
  children: []
}

export default manifest
